import { Component, inject, Signal, signal } from '@angular/core';
import { form, FormField, required, submit } from '@angular/forms/signals';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { UiButtonComponent } from '@app/shared/ui/button/ui-button.component';

import { ActiveCompanyService } from '@app/shared/services/active-company.service';
import { GroupsDataService } from '@app/shared/services/groups-data.service';
import { Company } from '@app/shared/types/models/company/company.model';
import { CompanyGroupFormModel, CreateCompanyGroupDialogData } from '@app/shared/types/models/group/group.model';
import { UiDialogComponent } from '@app/shared/ui/dialog/ui-dialog.component';
import { UiInputComponent } from '@app/shared/ui/input/ui-input.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'proffeo-create-company-group-dialog',
  imports: [MatDialogModule, TranslatePipe, UiDialogComponent, FormField, UiInputComponent, UiButtonComponent],
  templateUrl: './create-company-group-dialog.component.html'
})
export class CreateCompanyGroupDialogComponent {
  private readonly groupsDataService: GroupsDataService = inject(GroupsDataService);
  private readonly dialogRef: MatDialogRef<CreateCompanyGroupDialogComponent> = inject(
    MatDialogRef<CreateCompanyGroupDialogComponent>
  );
  private readonly dialogData: CreateCompanyGroupDialogData = inject(MAT_DIALOG_DATA);
  private readonly activeCompanyService: ActiveCompanyService = inject(ActiveCompanyService);

  protected readonly model = signal<CompanyGroupFormModel>({ name: '' });
  protected readonly form = form(this.model, path => {
    required(path.name);
  });
  protected activeCompany: Signal<Company | undefined> = this.activeCompanyService.activeCompany;

  public save(): void {
    void submit(this.form, {
      action: async () => {
        this.groupsDataService.addCompanyGroup(this.activeCompany()?.id, {
          name: this.model().name,
          parentGroupId: this.dialogData.parentGroupId
        });
        this.dialogRef.close();
      }
    });
  }
}
